import { Component, OnInit, OnDestroy } from '@angular/core';
import { Item } from 'src/app/models/item.model';
import {
    ItemService,
    AuthService,
    PushNotificationService,
    AlertService
} from '../../../services/service.index';
import { NgForm } from '@angular/forms';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-success',
    templateUrl: './success.component.html',
    styles: []
})
export class SuccessComponent implements OnInit, OnDestroy {

    data = [
        { id: 0, name: 'Imagen' },
        { id: 1, name: 'Video' },
    ];
    isImgOrVideo = this.data[0];
    isEvent = false;
    lat = 0;
    long = 0;
    count: any;
    loading = true;
    items: Item[] = [];
    LastEvaluatedKey = null;
    tag = 'success';
    item: Item = new Item('', '', '');
    file: any;
    page = 0;
    minidx = 0;
    itemsPerPage = 15;
    private unsubscribe$ = new Subject<void>();
    disabledPush: boolean;

    constructor(
        public itemService: ItemService,
        public _router: Router,
        private auth: AuthService,
        public pushNotification: PushNotificationService,
        private alertService: AlertService
    ) {
        if (!localStorage.getItem('isAdmin')) {
            this._router.navigate([`/home`]);
        }
    }

    ngOnInit() {
        this.loadItems();
        this.setCurrentLocation();
        this.getMessage();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    getMessage() {
        this.alertService.getAdminMessage().then(res => {
            res.subscribe((alert: any) => {
                this.disabledPush = alert.disabledPush;
            });
        });
    }

    loadItems() {
        this.items = [];
        this.loading = true;
        this.itemService.getItems(this.tag, this.LastEvaluatedKey)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((res: any) => {
                res.data.forEach(i => {
                    this.items.push(
                        new Item(
                            i.name,
                            i.description,
                            i.category,
                            i.tags,
                            i.item_picture,
                            i.geopoint ? i.geopoint._latitude : 0,
                            i.geopoint ? i.geopoint._longitude : 0,
                            i.cdate,
                            i.itemId,
                            i.video_url ? i.video_url : '',
                            i.stream_url ? i.stream_url : '',
                            i.clickMe,
                            i.finishDate ? i.finishDate : '',
                            i.startDate ? i.startDate : '',
                            i.address ? i.address : '',
                            i.original_link ? i.original_link : ''
                        ));
                });
                this.count = this.items.length;
                this.items = intoPages(this.items, this.itemsPerPage);
                this.loading = false;
            }, error => {
                if (error.status === 0 || error.status === 403) {
                    this.auth.getToken();
                    this.loadItems();
                }
            });
    }

    loadSearch(searchKey: any) {
        if (searchKey.length === 0) {
            this.loading = true;
            this.loadItems();
        } else {
            this.itemService
                .searchItemByName(searchKey, this.tag)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((res: any) => {
                    this.items = JSON.parse(res.body);
                    this.count = JSON.parse(res.count);
                    this.items
                        .sort((a, b) => {
                            const date1: any = new Date(a.cdate);
                            const date2: any = new Date(b.cdate);
                            return date1 - date2;
                        })
                        .reverse();
                    this.items = intoPages(this.items, this.itemsPerPage);
                    if (res.LastEvaluatedKey !== '') {
                        this.LastEvaluatedKey = res.LastEvaluatedKey;
                    }

                    this.loading = false;
                });
        }
    }

    getFileFromFileUpload(file: File) {
        this.file = file;
    }
    getLatFromMap(latm: number) {
        this.lat = latm;
    }
    getLongFromMap(longm: number) {
        this.long = longm;
    }

    addItem(form: NgForm) {
        this.item.name = form.value.name;
        this.item.description = form.value.description;
        // if (this.lat !== 0 && this.lat !== undefined) {
        //     this.item.lat = this.lat;
        // }
        // if (this.long !== 0 && this.long !== undefined) {
        //     this.item.long = this.long;
        // }
        this.item.stream_url = form.value.stream_url;
        this.item.clickMe = form.value.clickme;
        this.item.startdate = form.value.startDate;
        this.item.finishDate = form.value.endDate;
        this.item.tags.push(this.tag);
        this.item.category = '';
        Swal.fire({
            title: 'Agregando el item!',
            html: 'Espere unos segundos.',
            onBeforeOpen: () => {
                Swal.showLoading();
            }
        });
        if (this.isImgOrVideo.name !== 'Video') {
            if (this.file) {
                this.itemService
                    .uploadFile(this.file, this.tag)
                    .then((link: any) => {
                        this.item.item_picture = link;
                    })
                    .catch((err: Error) => {
                        Swal.close();
                        Swal.fire(
                            'El contenido no ha sido creado!',
                            'Su Evento no ha sido creado por problemas con la imagen.',
                            'error'
                        );
                        form.reset();
                    })
                    .finally(() => {
                        this.createEvent(this.item);
                        if (form.value.ispush) {
                            this.pushNotification
                                .postPushNotificationAll(this.item)
                                .pipe(takeUntil(this.unsubscribe$))
                                .subscribe(
                                    (pushRes: any) => {
                                        // console.log(pushRes);
                                    },
                                    error => {
                                        // console.log(error);
                                    }
                                );
                        }
                    });
            } else {
                Swal.fire(
                    'El contenido no ha sido creado!',
                    'Debe de ingresar un archivo de imagen válido.',
                    'error'
                );
            }
        } else {
            this.item.video_url = form.value.video;
            this.createVideoItem(this.item);
            if (form.value.ispush) {
                this.pushNotification
                    .postPushNotificationAll(this.item)
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe(
                        (pushRes: any) => {
                            // console.log(pushRes);
                        },
                        error => {
                            // console.log(error);
                        }
                    );
            }
        }
    }

    private setCurrentLocation() {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(position => {
                this.lat = position.coords.latitude;
                this.long = position.coords.longitude;
            });
        }
    }

    createEvent(item: Item) {
        return this.itemService
            .postEventItem(item)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (res: any) => {
                    this.item.itemId = res.id;
                },
                error => {
                    console.log('ERRROOOORRRR ', error);
                    Swal.fire(
                        'El contenido no ha sido creado con éxito!',
                        'Su item no ha sido creado contacte a soporte el problema si persiste.',
                        'error'
                    );
                },
                () => {
                    Swal.close();
                    Swal.fire(
                        'El contenido se ha creado con éxito!',
                        'Su evento creado podra ser visualizado en el app.',
                        'success'
                    );
                    this.loadItems();
                    this._router
                        .navigateByUrl('/', { skipLocationChange: true })
                        .then(() => this._router.navigate(['/items/' + 'success']));
                }
            );
    }

    createVideoItem(item: Item) {
        return this.itemService.postVideoItem(item)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((res: any) => {
                this.item.itemId = res.id;
            }, error => {
                Swal.fire('Ítem no ha sido creado con éxito!',
                    'Su ítem no ha sido creado contacte a soporte si el problema persiste.',
                    'error');
            }, () => {
                Swal.close();
                Swal.fire('Ítem creado con éxito!', 'Su ítem creado podrá ser visualizado en la aplicación.', 'success');
                this.loadItems();
                this._router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
                    this._router.navigate(['/items/' + 'success']));
            });
    }

    refresh(): void {
        window.location.reload();
    }

    updateItem(form: NgForm) {
        if (form.valid) {
            if (form.value.name !== '') {
                this.item.name = form.value.name;
            }
            if (form.value.description !== '') {
                this.item.description = form.value.description;
            }
            if (form.value.address !== '') {
                this.item.address = form.value.address;
            } else {
                this.item.address = '';
            }
            if (form.value.clickme !== '') {
                this.item.clickMe = form.value.clickme;
            } else {
                this.item.clickMe = '';
            }
            if (form.value.stream_url !== '') {
                this.item.stream_url = form.value.stream_url;
            } else {
                this.item.stream_url = '';
            }
            Swal.fire({
                title: 'Editando El contenido!',
                html: 'Espere unos segundos.',
                onBeforeOpen: () => {
                    Swal.showLoading();
                }
            });
            const putItem = this.itemService
                .putEventItem(this.item)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe(
                    (res: any) => { },
                    (err: any) => {
                        Swal.close();
                        Swal.fire(
                            'El contenido no ha sido editado con éxito!',
                            'Los cambios no podran ser visualizados en el app. ',
                            'error'
                        );
                    },
                    () => {
                        Swal.close();
                        Swal.fire(
                            'El contenido ha sido editado con éxito!',
                            'Los cambios al evento podran ser visualizados en el app. ',
                            'success'
                        ).then((res: any) => {
                            putItem.unsubscribe();
                        });
                    }
                );
            this.item = new Item('', '', '');
        }
    }

    parseTags(tagsFromItem: string): any {
        if (tagsFromItem.length > this.tag.length) {
            return true;
        } else {
            return false;
        }
    }

    firstPage() {
        this.page = 0;
        this.minidx = 0;
    }

    setPage(pageNumber: any) {
        this.page = pageNumber;
    }

    incPage() {
        if (this.page < this.items.length - 1) {
            this.page = this.page + 1;
            if (this.page >= this.minidx + 9) {
                if (this.minidx + 10 < this.items.length) {
                    this.minidx = this.minidx + 1;
                }
            }
        }
    }

    decPage() {
        if (this.page > 0) {
            this.page = this.page - 1;
            if (this.page < this.minidx + 1) {
                if (this.minidx > 0) {
                    this.minidx = this.minidx - 1;
                }
            }
        }
    }

    loadItemModal(itemToModal: Item) {
        this.item = itemToModal;
    }

    deleteItem(item: Item) {
        let deleteItem: any;
        Swal.fire({
            title: '¿Estás seguro?',
            text: 'Se eliminará El contenido: ' + item.name,
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#06d79c',
            cancelButtonColor: '#ef5350',
            confirmButtonText: 'Si',
            cancelButtonText: 'No',
            reverseButtons: true
        }).then(result => {
            if (result.value) {
                Swal.fire({
                    title: 'Borrando El contenido!',
                    html: 'Espere unos segundos.',
                    onBeforeOpen: () => {
                        Swal.showLoading();
                    }
                });
                deleteItem = this.itemService
                    .deleteItem(item.itemId)
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe(
                        (res: any) => { },
                        error => {
                            Swal.close();
                            Swal.fire('Error', 'El contenido no ha sido eliminado.', 'error');
                        },
                        () => {
                            Swal.close();
                            Swal.fire('Eliminado', 'El contenido ha sido eliminado.', 'success');
                            this.loadItems();
                            deleteItem.unsubscribe();
                        }
                    );
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire('Cancelado', 'No se hicieron cambios.', 'error');
            }
        });
    }

    getCoordinates(value: string) {
        if (value.match(/^https:\/\/www.google.com\/maps/)) {
            const point = value
                .match(/@([\d\.-]+),([\d\.-]+)/)
                .slice(1, 3)
                .map(n => parseFloat(n));
            this.lat = point[0];
            this.long = point[1];
        }
    }
}

export function intoPages(arr: any, pagelen: any) {
    const out = [];
    if (pagelen > arr.length) {
        out.push(arr);
    } else {
        for (let i = 0; i < Math.ceil(arr.length / pagelen); i++) {
            out.push(arr.slice(i * pagelen, (i + 1) * pagelen));
        }
    }
    return out;
}
